export const TRIGGER_TYPES = {
  AUTOMATICALLY: 'AUTOMATIC',
  MANUALLY: 'MANUAL'
};

export const TRIGGER_OPTIONS = {
  [TRIGGER_TYPES.AUTOMATICALLY]: {
    value: TRIGGER_TYPES.AUTOMATICALLY,
    label: 'models.trigger.automatically'
  },
  [TRIGGER_TYPES.MANUALLY]: {
    value: TRIGGER_TYPES.MANUALLY,
    label: 'models.trigger.manually'
  }
};

export const CRITERIA_OPERATION_TYPES = {
  OR: 'OR',
  AND: 'AND'
};

export const CRITERIA_TYPES = {
  TAG_PROPERTY: 'TAG_PROPERTY'
};

export const CRITERIA_OPTIONS = {
  [CRITERIA_TYPES.TAG_PROPERTY]: {
    value: CRITERIA_TYPES.TAG_PROPERTY,
    label: 'models.criteria.type.tagProperty'
  }
};

export const CRITERIA_TAG_TYPES = {
  SITE: 'SITE',
  AREA: 'AREA',
  ZONE: 'ZONE',
  LOCATION: 'LOCATION',
  BATTERY: 'BATTERY',
  TEMPERATURE: 'TEMPERATURE',
  SHOCK: 'SHOCK',
  HUMIDITY: 'HUMIDITY',
  LOST: 'LOST',
  TIME_IN_SERVICE: 'TIME_IN_SERVICE',
  CATEGORY: 'CATEGORY',
  GROUP: 'GROUP',
  FIELD1: 'FIELD1',
  FIELD2: 'FIELD2'
};

export const CRITERIA_TAG_OPTIONS = {
  [CRITERIA_TAG_TYPES.SITE]: {
    value: CRITERIA_TAG_TYPES.SITE,
    label: 'models.tag.site'
  },
  [CRITERIA_TAG_TYPES.AREA]: {
    value: CRITERIA_TAG_TYPES.AREA,
    label: 'models.tag.area'
  },
  [CRITERIA_TAG_TYPES.ZONE]: {
    value: CRITERIA_TAG_TYPES.ZONE,
    label: 'models.tag.zone'
  },
  [CRITERIA_TAG_TYPES.LOCATION]: {
    value: CRITERIA_TAG_TYPES.LOCATION,
    label: 'models.tag.location'
  },
  // [CRITERIA_TAG_TYPES.BATTERY]: {
  //   value: CRITERIA_TAG_TYPES.BATTERY,
  //   label: 'models.tag.batteryLevel'
  // },
  // [CRITERIA_TAG_TYPES.TEMPERATURE]: {
  //   value: CRITERIA_TAG_TYPES.TEMPERATURE,
  //   label: 'models.tag.temperature'
  // },
  // [CRITERIA_TAG_TYPES.SHOCK]: {
  //   value: CRITERIA_TAG_TYPES.SHOCK,
  //   label: 'models.tag.shock'
  // },
  // [CRITERIA_TAG_TYPES.HUMIDITY]: {
  //   value: CRITERIA_TAG_TYPES.HUMIDITY,
  //   label: 'models.tag.humidityLevel'
  // },
  // [CRITERIA_TAG_TYPES.LOST]: {
  //   value: CRITERIA_TAG_TYPES.LOST,
  //   label: 'models.tag.lost'
  // },
  // [CRITERIA_TAG_TYPES.TIME_IN_SERVICE]: {
  //   value: CRITERIA_TAG_TYPES.TIME_IN_SERVICE,
  //   label: 'models.tag.timeInService'
  // },
  [CRITERIA_TAG_TYPES.CATEGORY]: {
    value: CRITERIA_TAG_TYPES.CATEGORY,
    label: 'models.tag.category'
  },
  [CRITERIA_TAG_TYPES.GROUP]: {
    value: CRITERIA_TAG_TYPES.GROUP,
    label: 'models.tag.group'
  }
  // [CRITERIA_TAG_TYPES.FIELD1]: {
  //   value: CRITERIA_TAG_TYPES.FIELD1,
  //   label: 'models.tag.field1'
  // },
  // [CRITERIA_TAG_TYPES.FIELD2]: {
  //   value: CRITERIA_TAG_TYPES.FIELD2,
  //   label: 'models.tag.field2'
  // }
};

export const CRITERIA_TAG_PROPERTY_TYPES = {
  IN: 'IN',
  NOT_IN: 'NOT_IN',
  KNOWN: 'KNOWN',
  UNKNOWN: 'UNKNOWN',
  IS_LESS_THAN: 'LESS_THAN',
  IS_GREATER_THAN: 'GREATER_THAN',
  IS_LOST: 'LOST',
  IS_NOT_LOST: 'NOT_LOST',
  IS: 'IS',
  IS_NOT: 'NOT',
  EQUALS: 'EQUAL',
  NOT_EQUAL: 'NOT_EQUAL'
};

export const CRITERIA_TAG_PROPERTY_OPTIONS = {
  [CRITERIA_TAG_PROPERTY_TYPES.IN]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.IN,
    label: 'add.criteria.in',
    text: 'models.criteria.in',
    showValues: true
  },
  [CRITERIA_TAG_PROPERTY_TYPES.NOT_IN]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.NOT_IN,
    label: 'add.criteria.notIn',
    text: 'models.criteria.notIn',
    showValues: true
  },
  [CRITERIA_TAG_PROPERTY_TYPES.KNOWN]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.KNOWN,
    label: 'add.criteria.known',
    text: 'models.criteria.known',
    showValues: false
  },
  [CRITERIA_TAG_PROPERTY_TYPES.UNKNOWN]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.UNKNOWN,
    label: 'add.criteria.unknown',
    text: 'models.criteria.unknown',
    showValues: false
  },
  [CRITERIA_TAG_PROPERTY_TYPES.IS_LESS_THAN]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.IS_LESS_THAN,
    label: 'add.criteria.isLessThan',
    text: 'models.criteria.isLessTan',
    showValues: false
  },
  [CRITERIA_TAG_PROPERTY_TYPES.IS_GREATER_THAN]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.IS_GREATER_THAN,
    label: 'add.criteria.isGreaterThan',
    text: 'models.criteria.isGreaterThan',
    showValues: false
  },
  [CRITERIA_TAG_PROPERTY_TYPES.IS_LOST]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.IS_LOST,
    label: 'add.criteria.lost',
    text: 'models.criteria.lost',
    showValues: false
  },
  [CRITERIA_TAG_PROPERTY_TYPES.IS_NOT_LOST]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.IS_LOST,
    label: 'add.criteria.notLost',
    text: 'models.criteria.notLost',
    showValues: false
  },
  [CRITERIA_TAG_PROPERTY_TYPES.IS]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.IS,
    label: 'add.criteria.is',
    text: 'models.criteria.is',
    showValues: true
  },
  [CRITERIA_TAG_PROPERTY_TYPES.IS_NOT]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.IS_NOT,
    label: 'add.criteria.isNot',
    text: 'models.criteria.isNot',
    showValues: true
  },
  [CRITERIA_TAG_PROPERTY_TYPES.EQUALS]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.EQUALS,
    label: 'add.criteria.equals',
    text: 'models.criteria.equals',
    showValues: false
  },
  [CRITERIA_TAG_PROPERTY_TYPES.NOT_EQUAL]: {
    value: CRITERIA_TAG_PROPERTY_TYPES.NOT_EQUAL,
    label: 'add.criteria.notEqual',
    text: 'models.criteria.notEqual',
    showValues: false
  }
};

const assetProperties = [
  CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.IN],
  CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.NOT_IN],
  CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.KNOWN],
  CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.UNKNOWN]
];

const otherProperties = [
  CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.IS_LESS_THAN],
  CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.IS_GREATER_THAN],
  CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.KNOWN],
  CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.UNKNOWN]
];

export const CRITERIA_TAG_PROPERTY_COMPARE_OPTIONS = {
  [CRITERIA_TAG_TYPES.SITE]: assetProperties,
  [CRITERIA_TAG_TYPES.AREA]: assetProperties,
  [CRITERIA_TAG_TYPES.ZONE]: assetProperties,
  [CRITERIA_TAG_TYPES.LOCATION]: assetProperties,
  [CRITERIA_TAG_TYPES.BATTERY]: otherProperties,
  [CRITERIA_TAG_TYPES.TEMPERATURE]: otherProperties,
  [CRITERIA_TAG_TYPES.SHOCK]: otherProperties,
  [CRITERIA_TAG_TYPES.HUMIDITY]: otherProperties,
  [CRITERIA_TAG_TYPES.LOST]: [
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.LOST],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.NOT_LOST]
  ],
  [CRITERIA_TAG_TYPES.TIME_IN_SERVICE]: [
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.IS_LESS_THAN],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.IS_GREATER_THAN]
  ],
  [CRITERIA_TAG_TYPES.CATEGORY]: [
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.IS],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.IS_NOT]
  ],
  [CRITERIA_TAG_TYPES.GROUP]: [
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.IS],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.IS_NOT],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.KNOWN],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.UNKNOWN]
  ],
  [CRITERIA_TAG_TYPES.FIELD1]: [
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.EQUALS],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.NOT_EQUAL],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.KNOWN],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.UNKNOWN]
  ],
  [CRITERIA_TAG_TYPES.FIELD2]: [
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.EQUALS],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.NOT_EQUAL],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.KNOWN],
    CRITERIA_TAG_PROPERTY_OPTIONS[CRITERIA_TAG_PROPERTY_TYPES.UNKNOWN]
  ]
};

export const ACTION_TYPES = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  ALERT: 'ALERT'
};

export const ACTION_OPTIONS = {
  [ACTION_TYPES.EMAIL]: {
    icon: 'leaf',
    value: ACTION_TYPES.EMAIL,
    text: 'models.action.emailAction',
    label: 'models.action.email'
  },
  [ACTION_TYPES.SMS]: {
    icon: 'leaf',
    value: ACTION_TYPES.SMS,
    text: 'models.action.smsAction',
    label: 'models.action.sms'
  },
  [ACTION_TYPES.ALERT]: {
    icon: 'leaf',
    value: ACTION_TYPES.ALERT,
    text: 'models.action.alert',
    label: 'models.action.alert'
  }
};



// WEBPACK FOOTER //
// ./src/constants/triggers.js